import {
  requestObituary,
  requestFuneralObituaryList,
  requestCorpObituaryList,
  requestDirectorObituaryList,

  //
  requestMortuaryList,
  requestObituaryList,
  requestObituaryDelete,
  requestObituarySend,
  requestObituarySendAllOnly,
  requestObituaryOnlySend,
  requestObituaryOnlyReply,
  requestObituaryOnlyReplyKakao,
  requestObituaryOnlyMovie,
  requestObituaryReg,
  requestObituaryRegTmp,
  requestObituaryUpdate,
  requestObituaryDetail,
  requestObituaryAllList,
  //
  requestObituaryChangeCorp,
  requestObituarySendSelected
} from "@/apis/obituary_api";

import router from "@/router";
import { requestObituaryRegTmpLoad, requestObituaryRegTmpUpdate, requestObituarySendOther } from "../apis/obituary_api";

const state = {
  obituary: null,
  obituaryList: [],
  obituaryPage: null,
  obituaryPageTotal: 0,
  obituaryTotalElemtnts: 0,

  obituaryDetail: {},

  mainObituaryList: []
};

const getters = {
  getObituary(state) {
    return state.obituary;
  },
  getObituaryList(state) {
    return state.obituaryList;
  },
  getObituaryPage(state) {
    if (state.obituaryPage === null) {
      return 0;
    } else {
      return state.obituaryPage.pageNumber + 1;
    }
  },
  getObituaryPageTotal(state) {
    return state.obituaryPageTotal;
  },
  getObituaryTotalElements(state) {
    return state.obituaryTotalElemtnts;
  },
  getObituaryDetail(state) {
    return state.obituaryDetail;
  },

  getMainObituaryList(state) {
    return state.mainObituaryList;
  }
};

const mutations = {
  SET_OBITUARY(state, obituary) {
    state.obituary = obituary;
  },
  OBITUARY_LIST(state, data) {
    state.obituaryList = data.resultObituaryList;
    state.obituaryPage = data.page;
    state.obituaryPageTotal = data.pageTotal;
    state.obituaryTotalElemtnts = data.totalElemtnts;
  },

  OBITUARY_DETAIL(state, data) {
    state.obituaryDetail = data.obituaryDetail;
  },
  OBITUARY_INIT(state) {
    state.mortuaryList = [];
    state.obituaryList = [];
    state.obituaryPage = null;
    state.obituaryPageTotal = 0;
    state.obituaryTotalElemtnts = 0;

    state.obituaryDetail = {};
  },

  REQUEST_OBITUARY_ALL_LIST(state, data) {
    state.mainObituaryList = data.resultObituaryList;
  },
  REQUEST_OBITUARY_ALL_LIST_INIT(state) {
    state.mainObituaryList = [];
  }
};

const actions = {
  // 부고장 조회
  async REQUEST_OBITUARY_INFO({ commit }, { id }) {
    try {
      const response = await requestObituary(id);
      const { data } = response;

      commit("SET_OBITUARY", data);

      return true;
    } catch (error) {
      console.error(error);

      return false;
    }
  },

  // new
  async REQUEST_OBITUARY_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      let response;
      if (parameter.type === "funeral") {
        response = await requestFuneralObituaryList(parameter);
      } else if (parameter.type === "corp") {
        response = await requestCorpObituaryList(parameter);
      } else {
        response = await requestDirectorObituaryList(parameter);
      }
      const { data } = response;

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("OBITUARY_LIST", response.data);
      commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_OBITUARY_DETAIL({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryDetail(parameter.id);
      const { data } = response;

      if (data?.result !== "success") {
        alert(data.message);
        return false;
      }

      commit("OBITUARY_DETAIL", data);
      return true;
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      return false;
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_OBITUARY_SEND(context, parameter) {
    try {
      context.commit("START_LOADING");
      const response = await requestObituarySend(parameter.id);
      if (
        response.data !== null &&
        response.data !== undefined &&
        response.data.result === "success"
      ) {
        alert("발송을 완료하였습니다.");
      } else {
        alert(response.data.message);
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      alert(e);
      context.commit("END_LOADING");
    }
  },

  // 부고 재전송 - new
  async REQUEST_OBITUARY_ONLY_SEND({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryOnlySend(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert("발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // 부고 단체 재전송 - new
  async REQUEST_OBITUARY_ALL_SEND({ commit }, params) {
    try {
      commit("START_LOADING");

      const msgRes = await requestObituarySendAllOnly(
        params.obituaryId,
        params.msgType
      );

      if (msgRes.data.result !== "success") {
        return alert(msgRes.data.message);
      }

      alert("발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // 선택 전송 - new
  async REQUEST_OBITUARY_SELECTED_SEND({ commit }, params) {
    try {
      commit("START_LOADING");

      const msgRes = await requestObituarySendSelected(params);

      if (msgRes.data.result !== "success") {
        return alert(msgRes.data.message);
      }

      alert("발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // 상주 외 부고전송
  async REQUEST_OBITUARY_OTHER_SEND({ commit }, params) {
    try {
      commit("START_LOADING");

      const msgRes = await requestObituarySendOther(params);

      if (msgRes.data.result !== "success") {
        return alert(msgRes.data.message);
      }

      alert("발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_OBITUARY_REPLY_SEND({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryOnlyReply(parameter.id);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(response.data.message);
      }

      alert("답조글 발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // 추가추가추가추가
  async REQUEST_OBITUARY_REPLY_SEND_KAKAO({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryOnlyReplyKakao(parameter.id);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(response.data.message);
      }

      alert("답조글 발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_OBITUARY_REPLY_SEND_KAKAO_ALL({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const pArr = Array.from(parameter);

      pArr.forEach(async (param) => {
        const response = await requestObituaryOnlyReplyKakao(param);
        const { data } = response;
        if (data?.result !== "success") {
          return alert(response.data.message);
        }
      })

      alert("답조글 발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  //new - 추모영상 만들기
  async REQUEST_OBITUARY_REPLY_MOVIE({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryOnlyMovie(parameter.id);
      const { data } = response;
      if (data.result !== "success") {
        alert(data.message);
        return false;
      }

      return true;
    } catch (e) {
      if (e === "refresh") {
        return false;
      }
      alert(e);

      return false;
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_DELETE_OBITUARY({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryDelete(parameter);

      const { data } = response;

      if (data?.result !== "success") {
        alert(data.message);
      }

      commit("OBITUARY_LIST", response.data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_OBITUARY_REG({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryReg(parameter);
      const { data } = response;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      console.log(data.resultObituary);

      return data.resultObituary;

      // const obituaryId = data.resultObituary.id;

      // // const msgRes = await requestObituarySendAllOnly(obituaryId, "알림톡");

      // // if (msgRes.data.result !== "success") {
      // //   return alert(msgRes.data.message);
      // // }

      // alert("등록을 완료하였습니다.");

      // router.push({
      //   path: `/${parameter.type}/obituaryReg2`,
      //   query: {
      //     id: obituaryId
      //   }
      // });
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_OBITUARY_REG_TMP({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryRegTmp(parameter);
      const { data } = response;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      return data.resultObituary;
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_OBITUARY_REG_TMP_UPDATE({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryRegTmpUpdate(parameter);
      const { data } = response;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      return true;
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_OBITUARY_REG_TMP_LOAD({ commit }, id) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryRegTmpLoad(id);
      const { data } = response;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      console.log(data.tmpObituary);

      return data.tmpObituary;
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_OBITUARY_UPDATE({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestObituaryUpdate(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("OBITUARY_DETAIL", { obituaryDetail: data.resultObituary });

      const obituaryId = data.resultObituary.id;

      router.push({
        path: `/${parameter.type}/obituaryReg2`,
        query: {
          id: obituaryId
        }
      });
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_OBITUARY_ALL_LIST(context) {
    try {
      context.commit("START_LOADING");
      const response = await requestObituaryAllList();
      if (
        response.data !== null &&
        response.data !== undefined &&
        response.data.result === "success"
      ) {
        context.commit("REQUEST_OBITUARY_ALL_LIST", response.data);
      } else {
        alert(response.data.message);
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
    }
  },

  // new
  async REQUEST_OBITUARY_CHANGE_CORP({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryChangeCorp(parameter);
      const { data } = response;

      if (data?.result !== "success") {
        return alert(data.message);
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
